import ChatflowApi from "../../chatflow/api";

const state = {
  flows: [],
  channels: [],
};

const actions = {
  loadFlows: async ({ commit }) => {
    try {
      const flows = await ChatflowApi.getFlows();
      commit("setFlows", flows);
      return flows;
    } catch (err) {
      console.warn("[chatflows] loadFlows failed", err.response?.status, err.message);
      commit("setFlows", []);
      return [];
    }
  },
  loadChannels: async ({ commit }) => {
    try {
      const channels = await ChatflowApi.getChannels();
      commit("setChannels", channels);
      return channels;
    } catch (err) {
      console.warn("[chatflows] loadChannels failed", err.response?.status, err.message);
      commit("setChannels", []);
      return [];
    }
  },
};

const mutations = {
  setFlows: (state, flows) => (state.flows = flows),
  setChannels: (state, channels) => (state.channels = channels),
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
